import { EnumTipoOnereDTOTipoVincolo } from '@framework/api-client/api/inquiries/schemas/enumTipoOnereDTOTipoVincolo.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useTheme } from 'styled-components';

interface IBurdenConstraintTagProps {
  tipoVincolo?: EnumTipoOnereDTOTipoVincolo | null;
}

export function BurdenConstraintTag(props: IBurdenConstraintTagProps) {
  const theme = useTheme();
  const { tipoVincolo } = props;

  switch (tipoVincolo) {
    case EnumTipoOnereDTOTipoVincolo.OBBLIGATORIO:
      return (
        <StyledTag color={theme?.colorError}>
          {t('burdens-columns.obbligatorio', 'Obbligatorio')}
        </StyledTag>
      );
    case EnumTipoOnereDTOTipoVincolo.FACOLTATIVO:
      return (
        <StyledTag color={theme?.colorInfo}>
          {t('burdens-columns.facoltativo', 'Facoltativo')}
        </StyledTag>
      );
    case EnumTipoOnereDTOTipoVincolo.DA_PAGARE_DOPO_INVIO:
      return (
        <StyledTag color={theme?.colorWarning}>
          {t('burdens-columns.da-pagare-dopo-invio', "Da pagare dopo l'invio")}
        </StyledTag>
      );
    default:
      return null;
  }
}
